type SearchableField = string | null | undefined;

function matchesSimpleSearch(searchableFields: SearchableField[], search: string): boolean {
  const searchLower = search.toLowerCase();
  return searchableFields.some(field => field?.toLowerCase().includes(searchLower));
}

function matchesFullNameSearch(searchableFields: SearchableField[], search: string): boolean {
  const searchableText = searchableFields.filter(Boolean).join(' ').toLowerCase();
  return search
    .toLowerCase()
    .split(/[\s,]+/)
    .filter(Boolean)
    .every(term => searchableText.includes(term));
}

/**
 * Decides whether a record matches a search string across its searchable fields.
 *
 * When `fullNameSearch` is enabled the fields are joined into a single string and
 * every whitespace/comma-separated term must appear somewhere in it, so "John Doe"
 * matches a record whose first name is "John" and surname is "Doe". When disabled,
 * the legacy behaviour applies: the whole search string must be a substring of a
 * single field.
 *
 * Gated by the `flagEnabledClientSearchFullName` feature flag at each call site.
 */
export function matchesClientSearch(
  searchableFields: SearchableField[],
  search: string,
  fullNameSearch: boolean,
): boolean {
  if (search.trim() === '') return true;

  return fullNameSearch
    ? matchesFullNameSearch(searchableFields, search)
    : matchesSimpleSearch(searchableFields, search);
}
